module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Ne3Y9d/images/cover_image.jpg?1684245184881",
      "alt": "This image is the cover for the book Born to Rewild"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Born to Rewild\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("When Manda Kalimian began her mission to help America's wild horses—through rewilding—to regain their rightful place as a native species of the open plains, little did she know the challenges ahead would redefine everything she understood about who she thought she was. Born to Rewild follows Manda as she joins the struggle to rescue wild horses from a program fraught with bureaucracy, controversy, and the potential to erase the legacy of these beautiful creatures from land that depends on their very existence. With this journey, Manda joins forces with new friends in the Native American community-all dedicated to restoring the wild horse to its natural environment through the process of rewilding. Born to Rewild: Triumphs of a Now Fearless Woman is an inspirational and passionate story of one woman's dedication to conservation and the rewilding of America's truly native wild horses.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Manda Kalimian\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    © Manda Kalimian\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0